import { Record } from 'immutable';
import { getFlag } from '../../configureFlags';

import {
  SET_HIGHLIGHTED_BUTTON,
  UPDATE_RIGHT_SIDEBAR,
} from './actions';

const storedVisibleFlag = getFlag('mb-right-sidebar-visible');

const sidebarVisible = window.innerWidth > 1200
  ? (!storedVisibleFlag || storedVisibleFlag === 'true')
  : false;

export const Metadata = new Record({
  betslipTab: 'betslip' // ['betslip', 'active-bets', 'bet-builder']
});

const InitialState = new Record({
  visible: sidebarVisible,
  content: getFlag('mb-right-sidebar-content') || 'betslip',
  metadata: new Metadata(),
  highlightedButton: ''
});

export const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_RIGHT_SIDEBAR: {
      const {
        visible = true,
        content = '',
        metadata = {}
      } = payload;

      return state
        .set('visible', visible)
        .set('content', content)
        .set('metadata', new Metadata(metadata));
    }
    case SET_HIGHLIGHTED_BUTTON: {
      return state.set('highlightedButton', payload);
    }
    default:
      return state;
  }
};
